import React from 'react'

import PaginatorPagesList from './paginator-pages-list'

const Paginator = ({currentPage, pages, setCurrentPage}) => {
  const paginatorSize = 7;

  const handleArrowClick = event => {
    event.preventDefault();
    const {className} = event.target.parentElement;

    if (className.indexOf('angle-back') > -1) {
      setCurrentPage(--currentPage);
    } else if (className.indexOf('angle-forward') > -1) {
      setCurrentPage(++currentPage);
    }
  };

  const handlePageClick = event => {
    event.preventDefault();

    const number = parseInt(event.target.textContent);

    if (number) {
      setCurrentPage(number);
    }
  };

  const hiddenBackArrow = currentPage <= 1  && 'hidden';
  const hiddenForwardArrow = currentPage >= pages  && 'hidden';

  return (
    <div className="page-nav-wrapper">
      <div className={"angle-back " + hiddenBackArrow}>
        <span onClick={handleArrowClick}/>
      </div>
      <PaginatorPagesList currentPage={currentPage}
                          pages={pages}
                          handlePageClick={handlePageClick}
                          paginatorSize={paginatorSize}/>
      <div className={"angle-forward " + hiddenForwardArrow}>
        <span onClick={handleArrowClick}/>
      </div>
    </div>
  )
};

export default Paginator
